import React from "react";
import { IListAction } from "../../../interfaces/common/IListAction";
import { Button } from "react-bootstrap";

export default function ListActions({ handleAction, classAction, title, textButton }: IListAction) {
   

    return (
        <section className="list-actions">
            <Button className={`btn-md btn-primary ${classAction}`} title={title} onClick={handleAction}>
                <span className="icon"></span>
                <span className="text">{textButton}</span>
            </Button>
        </section>
    );
}